module.exports = __webpack_public_path__ + "static/media/1_ei-koyhyytta.a71bc87d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/1_ei-koyhyytta.svg
// module id = ./src/images/agendaIcons/1_ei-koyhyytta.svg
// module chunks = 1